import requester from "api/requester"
import { IAuthAPI } from "./types"
import zozoFitRequester from "api/zozoFitRequester"

const authAPI: IAuthAPI = {
  loginWithEmail: (payload) => {
    return requester.post(`/accounts/token/sign-in`, payload)
  },

  getFitProfile() {
    return zozoFitRequester.get(`/v2/users/profile`)
  },

  createAccount() {
    return zozoFitRequester.post(`/v2/accounts`, {})
  },

  createFitProfile(payload) {
    return zozoFitRequester.put(`/v2/users/profile`, payload)
  },

  updateEmailSubscription(payload) {
    return zozoFitRequester.put(`/v2/accounts/email-subscription`, payload)
  },
}

export default authAPI
